import { render } from "./CarteTransactions.vue?vue&type=template&id=4af60958&ts=true"
import script from "./CarteTransactions.vue?vue&type=script&lang=ts"
export * from "./CarteTransactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__